<template>
  <section>
    <div class="action-buttons">
      <div class="action-button">
        <button
          v-if="modifiedRows.length"
          class="button field is-green is-medium"
          id="clear"
          @click="validateModifications"
          :disabled="!modifiedRows.length"
        >
          <span>
            <i class="fal fa-check"></i> Valider les modifications
          </span>
        </button>
      </div>
      <div class="action-button">
        <button
          v-if="modifiedRows.length"
          class="button field is-danger is-medium"
          id="clear"
          @click="cancelModifications"
          :disabled="!modifiedRows.length"
        >
          <span>
            <i class="fal fa-times"></i> Annuler les modifications
          </span>
        </button>
      </div>
    </div>

    <b-table
      class="b-table"
      :data="myData"
      :striped="true"
      :hoverable="true"
      :loading="isLoading"
      :mobile-cards="false"
    >
      <template
        slot-scope="props"
        slot="header"
      >
        <b-tooltip
          :active="!!props.column.meta"
          :label="props.column.meta"
        >{{ props.column.label }}</b-tooltip>
      </template>
      <template slot-scope="props">
        <b-table-column
          meta="Nom du Weezy"
          field="weezy_id"
          label="Weezy"
          :centered="true"
          :sortable="true"
          :custom-sort="sortByWeezy"
        >{{ props.row.name }}</b-table-column>

        <b-table-column
          meta="Nombre de Ventes avant déclenchement du mini-jeu (0 = pas de mini-jeu)"
          field="game_sales_trigger"
          label="Seuil mini-jeu (ventes)"
          :centered="true"
          :sortable="true"
        >
          <b-input
            id="goal_reload"
            class="b-input-number"
            type="number"
            min="0"
            oninput="this.value = Math.abs(this.value).toFixed(0)"
            v-model="props.row.game_sales_trigger"
            @input="toggleModified(props.row)"
          ></b-input>
        </b-table-column>

        <!-- Voix Homme / Femme -->
        <b-table-column
          meta="Choix de la voix (Homme ou Femme)"
          field="tts_is_female_voice"
          label="Choix de la voix"
          :centered="true"
          :sortable="true"
        >
          <div style="display: flex">Homme
            <b-switch
              type="is-info"
              style="margin-left: 5px"
              v-model="props.row.tts_is_female_voice"
              @input="toggleModified(props.row)"
            ></b-switch> Femme
          </div>
        </b-table-column>

        <!-- Vitesse de parole -->
        <b-table-column
          field="tts_speech_rate"
          label="Vitesse de parole"
          width="222"
          meta="Défini la vitesse de l'énonciation des annonces du Weezy"
          :centered="true"
        >
          <input
            type="range"
            min="1"
            max="20"
            v-model="props.row.tts_speech_rate"
            @input="toggleModified(props.row)"
          >
          {{props.row.tts_speech_rate}}
        </b-table-column>

        <!-- Ton de parole -->
        <b-table-column
          field="tts_pitch"
          label="Ton de parole"
          width="222"
          meta="Défini le ton de l'énonciation des annonces du Weezy"
          :centered="true"
        >
          <input
            type="range"
            min="1"
            max="20"
            v-model="props.row.tts_pitch"
            @input="toggleModified(props.row)"
          >
          {{props.row.tts_pitch}}
        </b-table-column>

        <!-- Annonce début défi -->
        <b-table-column
          meta="Ce que weezy dit quand un défi commence"
          field="tts_challenge_started"
          label="Annonce début défi"
          width="200px"
          :centered="true"
          :sortable="true"
        >
          <b-input
            id="tts_challenge_started"
            class="b-input-textarea"
            type="textarea"
            v-model="props.row.tts_challenge_started"
            @input="toggleModified(props.row)"
          ></b-input>
        </b-table-column>

        <!-- Annonce batterie faible -->
        <b-table-column
          meta="Ce que weezy dit quand sa batterie est faible"
          field="tts_low_battery"
          label="Annonce batterie faible"
          width="200"
          :centered="true"
          :sortable="true"
        >
          <b-input
            id="tts_low_battery"
            class="b-input-textarea"
            type="textarea"
            v-model="props.row.tts_low_battery"
            @input="toggleModified(props.row)"
          ></b-input>
        </b-table-column>

        <!-- Annonce en charge -->
        <b-table-column
          meta="Ce que weezy dit quand on le met en charge"
          field="tts_plugged_in"
          label="Annonce charge"
          width="200"
          :centered="true"
          :sortable="true"
        >
          <b-input
            id="tts_plugged_in"
            class="b-input-textarea"
            type="textarea"
            v-model="props.row.tts_plugged_in"
            @input="toggleModified(props.row)"
          ></b-input>
        </b-table-column>

        <!-- Annonce Màj disponible -->
        <b-table-column
          meta="Ce que weezy dit quand une mise à jour est dispnible commence"
          field="tts_update_available"
          label="Annonce màj"
          width="200"
          :centered="true"
          :sortable="true"
        >
          <b-input
            id="tts_update_available"
            class="b-input-textarea"
            type="textarea"
            v-model="props.row.tts_update_available"
            @input="toggleModified(props.row)"
          ></b-input>
        </b-table-column>
      </template>

      <template slot="empty">
        <section class="section">
          <div
            v-if="!isLoading"
            class="content has-text-grey has-text-:centered"
          >
            <p>Pas de Weezy à personnaliser</p>
          </div>
        </section>
      </template>
    </b-table>
  </section>
</template>

<script>
import _ from "lodash";

export default {
  name: "WeezysTable",
  props: ["weezys"],
  data: () => {
    return {
      isLoading: true,
      modifiedRows: [],
      myData: [],
      storedWeezys: []
    };
  },
  watch: {
    weezys: function(newVal, oldVal) {
      // watch it
      this.myData = this.weezys;
      this.storedWeezys = JSON.parse(JSON.stringify(this.weezys));
      this.isLoading = false;
    }
  },
  methods: {
    debounceModif: _.debounce(async function(e) {
      this.$parent.modifyRows(e);
    }, 500),

    toggleModified(raaw) {
      this.debounceModif([raaw]);
      // var modified = false;
      // this.modifiedRows.push(raaw);
      // for (var j = 0; j < this.modifiedRows.length; j++) {
      //   var row = this.modifiedRows[j];
      //   for (var i = 0; i < this.storedWeezys.length; i++) {
      //     var weezy = this.storedWeezys[i];
      //     if (weezy.id == row.id) {
      //       if (
      //         !(
      //           weezy.tts_is_female_voice == row.tts_is_female_voice &&
      //           weezy.game_sales_trigger == row.game_sales_trigger &&
      //           weezy.tts_update_available == row.tts_update_available &&
      //           weezy.tts_speech_rate == row.tts_speech_rate &&
      //           weezy.tts_pitch == row.tts_pitch &&
      //           weezy.tts_challenge_started == row.tts_challenge_started &&
      //           weezy.tts_plugged_in == row.tts_plugged_in &&
      //           weezy.tts_low_battery == row.tts_low_battery
      //         )
      //       )
      //         modified = true;
      //     }
      //   }
      // }
      // if (!modified) {
      //   this.modifiedRows = [];
      // }
    },
    validateModifications() {
      this.$parent.modifyRows(this.modifiedRows);
      setTimeout(() => {
        this.modifiedRows = [];
      }, 100);
    },
    cancelModifications() {
      this.$parent.getWeezys();
      setTimeout(() => {
        this.modifiedRows = [];
      }, 100);
    },
    sortByWeezy(a, b, isAsc) {
      if (isAsc) {
        return b.name.toLowerCase() < a.name.toLowerCase() ? -1 : 1;
      } else {
        return b.name.toLowerCase() > a.name.toLowerCase() ? -1 : 1;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media screen and (max-width: 768px) {
  .b-input-textarea {
    width: 100px !important;
  }

  .action-buttons {
    display: flow-root;
  }

  .action-buttons,
  .action-button {
    float: unset;
  }

  .b-table {
    margin-top: 2em;
  }
}

@media screen and (min-width: 768px) {
  .b-input-textarea {
    width: 300px !important;
  }
}

.b-table {
  width: 100%;
  padding-right: 20px;
  overflow-x: scroll;
}

.b-input-number {
  width: 80px;
  margin-left: 15px;
  text-align: center;
  align-content: center;
  display: inline-block;
}
.has-text-centered {
  vertical-align: inherit;
}

.select-logo {
  height: 50px;
  display: inline;
}

.action-buttons {
  margin-top: 0px;
}
</style>